export default "__VITE_PUBLIC_ASSET__9bd789e7__"